import React from 'react';
import { AmenitiesType } from '../../Components/Types';
import { Icon, IconContainer, Item, ItemText } from './AmenitiesComponents';

type AmenitiesProps = {
    amenities: AmenitiesType[];
};

function Amenities({ amenities }: AmenitiesProps) {
    return (
        <IconContainer>
            {amenities?.map((amenity: AmenitiesType, i) => (
                <Item key={i}>
                    <Icon
                        src={`/images/motorhome/amenities/${amenity.image_path}`}
                        alt={`${amenity.label}`}
                        title={`${amenity.label}`}
                    />
                    <ItemText>{amenity.label}</ItemText>
                </Item>
            ))}
        </IconContainer>
    );
}
export default Amenities;
